import React from 'react';
import './DiscrepancyPopup.css';
import Popup from '../../components/popup/Popup';
import Label from '../../components/label/Label';
import Button from '../../components/button/Button';
import Card from '../../components/card/Card';
import Input from '../../inputs/input/Input';
import FormTemplate from '../../components/templates/formTemplates/FormTemplate';

export default class DiscrepancyPopup extends FormTemplate {
	_confirm = async () => {
		if (!this.isValid()) return;
		let value = this.getValue();
		value.id = this.props.id;
		let success = await this.props.onComplete(value);
		if (success) {
			// window.popupController.hide(DiscrepancyPopup);
			this.props.onClose();
		}
	};

	render() {
		let show = this.props.show;
		if (!this.props.hasOwnProperty('show')) {
			show = true;
		}
		return (
			<Popup {...this.props} show={show} className="g-discrepancy-popup">
				<Card>
					<Label large black>
						{this.props.title}
					</Label>
					<Input ref={(ref) => (this.myRefs.notes = ref)} placeholder={this.props.notesPlaceholder} required />
					<div className="actions">
						<Button color="white" bg="blue" onClick={this.props.onClose}>
							No
						</Button>
						<Button color="white" bg="red" onClick={this._confirm}>
							Yes
						</Button>
					</div>
				</Card>
			</Popup>
		);
	}
}



// WEBPACK FOOTER //
// ./src/popups/discrepancyPopup/DiscrepancyPopup.jsx